import React from 'react'
import PropTypes from 'prop-types'
import { getTranslation } from '../translations'

export default function WaterDisclaimer({ language = 'english', partnerName = 'Ekosight', customText = null }) {
  const t = getTranslation(language)
  if (customText) {
    return (
      <div className="mt-8 mb-8">
        <h2 className="text-xl font-extrabold text-[#134225] text-center mb-6">{t.disclaimer}</h2>
        <div className="max-w-5xl mx-auto text-gray-700 leading-7 text-sm text-justify">
          <p style={{ whiteSpace: 'pre-wrap' }}>{customText}</p>
        </div>
      </div>
    )
  }
  
  const disclaimerText = t.waterDisclaimerTextWithPartner.replace(/\[Partner Name\]/g, partnerName)
  
  return (
    <div className="mt-8 mb-8">
      <h2 className="text-xl font-extrabold text-[#134225] text-center mb-6">{t.disclaimer}</h2>
      <div className="max-w-5xl mx-auto text-gray-700 leading-7 text-sm text-justify">
        <p>{disclaimerText}</p>
      </div>
    </div>
  )
}

WaterDisclaimer.propTypes = {
  language: PropTypes.oneOf(['english', 'hindi', 'punjabi']),
  partnerName: PropTypes.string
}
